n<template>
  <v-layout>
      <v-flex>                    
        <v-data-table
        :headers="headers"
        :items="tarifarios"        
        :search="search"
        class="elevation-1"
        >
        <template v-slot:item.activo="{ item }">  
            <div v-if="item.activo  ">
                <span class="blue--text">Activo</span>
                
            </div>
            <div v-else>
                <span class="red--text">Pendiente</span>                
            </div>                  
        </template>
        <template v-slot:top>
            <v-toolbar flat color="white">
                <v-toolbar-title>Tarifarios</v-toolbar-title>
                <v-divider
                    class="mx-4"
                    inset
                    vertical
                ></v-divider>
                <v-spacer></v-spacer>
                <v-text-field class="text-xs-center" v-model="search" append-icon="search" label="Búsqueda" single-line hide-details></v-text-field>
                <v-spacer></v-spacer> 
                <v-dialog v-model="dialog" max-width="500px">
                    <template v-slot:activator="{ on }">
                    <v-btn color="primary" dark class="mb-2" v-on="on">Nuevo</v-btn>
                    </template>
                    <v-card>
                    <v-card-title>
                        <span class="headline">{{ formTitle }}</span>
                    </v-card-title>
                    <v-card-text>
                        <v-container>
                            <v-row>                                
                                <v-col cols="6" sm="6" md="6">
                                    <v-select item-text="text" return-object item-value="value" v-model="idproveedor" :items="proveedor" label="Proveedor">
                                    </v-select>
                                </v-col>                                
                                <v-col cols="12" sm="6" md="6">
                                <v-menu
                                    v-model="menu2"
                                    :close-on-content-click="false"
                                    :nudge-right="40"
                                    transition="scale-transition"
                                    offset-y
                                    min-width="290px"
                                >
                                    <template v-slot:activator="{ on }">
                                    <v-text-field
                                        v-model="date"
                                        label="Validez"
                                        prepend-icon="event"
                                        readonly
                                        v-on="on"                                        
                                    ></v-text-field>
                                    </template>
                                    <v-date-picker no-title locale="es-419" v-model="date" @input="menu2 = false"></v-date-picker>
                                </v-menu>
                                </v-col>
                                <v-col cols="12" sm="12" md="12">
                                      <v-file-input accept='.xls' v-model="url" multiple label="Seleccionar archivo"></v-file-input>
                                </v-col>                                                               
                                <v-col cols="12" sm="12" md="12" v-show="valida">
                                    <div class="red--text" v-for="v in validaMensaje" :key="v" v-text="v"></div>
                                </v-col>                                                        
                            </v-row>
                        </v-container>
                    </v-card-text>    
                    <v-card-actions>
                        <v-spacer></v-spacer>
                        <v-btn color="blue darken-1" text @click="close">Cancelar</v-btn>
                        <v-btn color="blue darken-1" text @click="agregar()">Guardar</v-btn>
                    </v-card-actions>
                    </v-card>
                </v-dialog>
                <v-dialog  v-model="adModal" max-width="290px">
                    <v-card>
                        <v-card-title class="headline" v-if="adAccion==1">¿Activar Item?</v-card-title>
                        <v-card-title class="headline" v-if="adAccion==2">¿Desactivar Item?</v-card-title>
                        <v-card-text>
                            Estás a punto de
                            <span v-if="adAccion==1">Activar</span>
                            <span v-if="adAccion==2">Desactivar</span>
                            el item {{ adNombre }}
                        </v-card-text>
                        <v-card-actions>
                             <v-spacer></v-spacer>
                             <v-btn color="green darken-1" text="text" @click="activarDesactivarCerrar">
                                 Cancelar
                             </v-btn>
                             <v-btn v-if="adAccion==1" color="orange darken1" text="text" @click="activar">
                                 Aceptar
                             </v-btn>
                             <v-btn v-if="adAccion==2" color="orange darken1" text="text" @click="desactivar">
                                 Desactivar
                             </v-btn>
                        </v-card-actions>
                    </v-card>
                </v-dialog>
            </v-toolbar>
        </template>
        <template v-slot:item.opciones="{ item }">
            <v-icon
            small
            class="mr-2"
            @click="editItem(item)"
            >
            edit
            </v-icon>
            <template v-if="item.activo">                         
                   <v-icon
                    small
                    @click="activarDesactivarMostrar(2,item)"
                    >
                    block
                    </v-icon>                               
            </template>
            <template v-else>                         
                   <v-icon
                    small
                    @click="activarDesactivarMostrar(1,item)"
                    >
                    check
                    </v-icon>                               
            </template> 
        </template>
        <template slot="no-data">
            <v-btn colo="primary" @click="listar">Resetear</v-btn>
        </template>     
        </v-data-table>                        
      </v-flex>
      <v-snackbar
        v-model="snackbar"
        color="cyan darken-2" 
        top
        timeout="6000"
        >
        {{ mensaje }}
        <v-btn
            dark
            text
            @click="snackbar = false"
        >
            Close
        </v-btn>            
        </v-snackbar> 
  </v-layout>
</template>


<script>
import axios from 'axios'      
export default {
    data(){
        return{
            mensaje:'',
            date: new Date().toISOString().substr(0, 10),            
            menu2: false,
            tarifarios:[], 
             adModal:false,            
             dialog: false,
                headers: [
                { text: 'OPCIONES', value: 'opciones', sortable: false },                            
                { text: 'USUARIO', value: 'nombreus' },
                { text: 'PROVEEDOR', value: 'nombreprov', sortable: false }, 
                { text: 'ARCHIVO', value: 'nombrearchivo' },
                { text: 'VALIDEZ', value: 'fechavalidez' },
                { text: 'ESTADO', value: 'activo' },                                          
                ],
                search:'',
                editedIndex: -1,              
                id:'',
                idusuario:'',
                url:'',
                idproveedor:'',
                idpuerto:'',
                proveedor:[],
                codigo:'',
                fechav:'',
                nombre:'',
                descripcion:'',                
                valida:'',
                validaMensaje:[],                
                adAccion:0,
                adNombre:'',
                adId:'',
                snackbar:false,          
        }
    },
    computed: {
        formTitle () {//si editedIndex es igual a menos uno estamos agregando un dato nuevo de lo contrario vamos a editar un dato existente
            return this.editedIndex === -1 ? 'New Port' : 'Update Port'
        },
    },

    watch: {
        dialog (val) {
            val || this.close()
        },        
    },

    created () {        
        this.listar();
        this.select();
    },
    methods:{   
        agregar(){
            console.log(this.url)
             this.tarifarios.push({
                 nombreus:'Alejandro Guerrero',
                 nombreprov:this.idproveedor.text,
                 nombrearchivo:this.url[0].name,
                 fechavalidez:this.date,
                 activo:false
             });
             this.dialog = false;
             this.snackbar = true;               
             this.mensaje = 'Informacion capturada, te avisaremos en cuanto las tarifas sean registradas';
        },    
        listar(){//mandamos llamar el controlador Categorias y asu accion Listar y guardamos la informacion que nos devuelve en la variable response
            let me=this;//this para que pueda ser utilizada en cualquiier llamado de aacion 
            let header={"Authorization" : "Bearer " + this.$store.state.token};
            let configuracion ={headers:header};
            axios.get('api/Tarifarios/Listar',configuracion).then(function(response){
              //console.log(response);
              me.tarifarios=response.data;
            }).catch(function(error){
              console.log(error);
            });
        },
        select(){//mandamos llamar el controlador Puertos y asu accion Listar y guardamos la informacion que nos devuelve en la variable response
            let me=this;//this para que pueda ser utilizada en cualquiier llamado de aacion 
            let header={"Authorization" : "Bearer " + this.$store.state.token};
            let configuracion ={headers:header};
            var proveedorArray=[];
            axios.get('api/Datos/SelectProveedor',configuracion).then(function(response){              
              proveedorArray=response.data;
              proveedorArray.map(function(x){
                  me.proveedor.push({text:x.nombre,value:x.iddatos});
              });            
            }).catch(function(error){
              console.log(error);
            });
        },
        editItem (item) {
            this.id=item.idtarifario;
            this.idusuario=item.idusuario;
            this.idproveedor=item.iddatos;
            this.url=item.nombrearchivo;
            this.date=item.fechavalidez;
            this.editedIndex=1;
            this.dialog = true
        },
        close () {
            this.dialog = false;            
            this.limpiar();
        },
        limpiar(){
            this.id="";
            this.nombre="";
            this.date="";
            this.url="";
            this.descripcion="";
            this.idproveedor="";
            this.codigo="";            
            this.editedIndex=-1;
        },
        guardararchivo(){
            let formData = new FormData();

            for( var i = 0; i < this.url.length; i++ ){
            let file = this.url[i];

            formData.append('files[' + i + ']', file);
            }

            axios.post( 'api/Tarifarios/SubirArchivos',
            formData,
            {
                headers: {
                    'Content-Type': 'multipart/form-data'
                }
            }
            ).then(function(){
            console.log('Correcto!');
            })
            .catch(function(){
            console.log('Error!');
            });
        },
        guardar () {
            if(this.validar()){
                return;
            }
            let header={"Authorization" : "Bearer " + this.$store.state.token};
            let configuracion ={headers:header};           
            let formData = new FormData();
            formData.append('file', this.url);
            let headerurl={'Content-Type': 'multipart/form-data'};
            let archivo={formData:headerurl};       
            if (this.editedIndex > -1) {//codigo para editar            
                let me=this;                
                axios.put('api/Tarifarios/Actualizar',{
                    'idtarifario':me.id,
                    'idusuario':me.idusuario,
                    'idproveedor':me.idproveedor,                    
                    'nombrearchivo':me.archivo,
                    'fechavalidez':me.date
                },configuracion).then(function(response){
                    me.close();
                    me.listar();
                    me.limpiar();
                }).catch(function(error){
                    console.log(error);
                });  
            }else{//codigo para guardar
                let me=this;
                axios.post('api/Tarifarios/Crear',{
                    'idusuario':1,
                    'idproveedor':me.idproveedor,                    
                    'nombrearchivo':'archivoprueba.xml',
                    'fechavalidez':me.date
                },configuracion).then(function(response){
                    me.close();
                    me.listar();
                    me.limpiar();
                }).catch(function(error){
                    console.log(error);
                });                
            }            
        },
        validar(){
            this.valida=0;
            this.validaMensaje=[];
            return this.valida;
        },
        activarDesactivarMostrar(accion,item){
           this.adModal=true;
           this.adNombre=item.nombre;
           this.adId=item.idpuerto;
            if(accion==1)
            {
                this.adAccion=1;                
            }
            else if(accion==2){
                this.adAccion=2;
            }
            else{
                this.adModal=false;
            }
        },
        activarDesactivarCerrar(){
            this.adModal=false;
        },
        activar(){
            let me=this;
            let header={"Authorization" : "Bearer " + this.$store.state.token};
            let configuracion ={headers:header};
            axios.put('api/Puertos/Activar/'+this.adId,{},configuracion).then(function(response){
                me.adModal=false;
                me.adAccion=0;
                me.adNombre="";
                me.adId="";
                me.listar();
            }).catch(function(error){
                console.log(error);
            }); 
        },
        desactivar(){
            let me=this;
            let header={"Authorization" : "Bearer " + this.$store.state.token};
            let configuracion ={headers:header};
            axios.put('api/Puertos/Desactivar/'+this.adId,{},configuracion).then(function(response){
                me.adModal=false;
                me.adAccion=0;
                me.adNombre="";
                me.adId="";
                me.listar();
            }).catch(function(error){
                console.log(error);
            });
        },
    }
}
</script>